import React, { useState, useEffect } from 'react';
import ResizeDetector from "react-resize-detector";
import { useDispatch } from 'react-redux'
import 'react-phone-input-2/lib/style.css';
import { useParams } from 'react-router-dom';
import { Respondent_Survey } from '../../actions/auth_actions';
import SecureLS from 'secure-ls';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';
import { getSurveyReplyPointsSummary } from '../../actions/activities_reply_actions'
import QualityChecksModal from '../../assets/components/modal/qualityChecksModal';


const ThanksYouMsg = () => {

    const [isLoading, setLoading] = useState(true)
    const [showQualityCheckModal, set_showQualityCheckModal] = useState(false);
    const [pointsSummary, set_pointsSummary] = useState({})
    const ls = new SecureLS
    const dispatch = useDispatch()
    const params = useParams()






    const sendRespondentDataForEmail = () => {
        const userId = ls.get('accessUser').user? ls.get('accessUser').user._id : params.UserId 
        dispatch(Respondent_Survey(userId, params.ActivityId))
            .then((response) => {
                console.log('success')
            }).catch((err) => {
                console.log('err')
            })




    }

    const getPointsSummary = () => {

        dispatch(getSurveyReplyPointsSummary(params.ActivityId))
            .then((response) => {

                if (response.payload.message === 'Replies Quality Checks Found') {
                    set_showQualityCheckModal(true)
                    set_pointsSummary(response.payload.content)
                }

            })
            .catch((err) => {
                console.log('err')
            })
    }

    useEffect(() => {
        sendRespondentDataForEmail()
        getPointsSummary()
    }, [])



    return (
        <ResizeDetector
            handleWidth
            render={({ width, height }) => (
                <LoadingOverlay tag="div"
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: "#fff",
                            opacity: 0.5,
                            // position: 'fixed',
                            // top: '2%'
                        }),
                    }}
                    spinner={
                        <Loader color="#6c757d" active type="ball-pulse" />
                    }>


                    <div className="_signup_">

                        <div className="d-flex">
                            <div className="col-lg-8 col-12">

                                {/* Logo */}
                                <div className={height > 768 && width > 800 ? "container-fluid position-fixed m-3" : "container-fluid my-3 mr-3"}>
                                    <a href="/">
                                        <img src={require('../../assets/utils/images/logo.png')} alt="logo" width='135' />
                                    </a>
                                </div>
                                {showQualityCheckModal && (
                                    <QualityChecksModal
                                       pointsSummary={pointsSummary}
                                        isModalOpen={showQualityCheckModal}
                                        toggle={() => set_showQualityCheckModal(false)}
                                    />
                                )}
                                <div className="container">
                                    <div className={`row justify-content-center align-items-center ${height > 768 && width > 800 ? 'h-100' : 'mt-5'}`}>
                                        <div className="col-12">

                                            <h4 className="mb-5 ml-4">

                                                <h3 className="text-dark mb-2" style={{ fontWeight: '500' }}>Response has been Submitted  </h3>
                                                <p style={{ fontSize: '1rem' }}>Thank You for Submitting Your Response.</p>
                                            </h4>

                                            {/* <div className="row"> */}



                                            {/* </div> */}



                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="col-lg-4 d-lg-block d-none side_bg px-0">
                                {/* Gradient Overlay */}
                                <div className="grad_overlay"></div>

                                <div className="text-center px-3">
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <div className="col-12">
                                            {/* <h3 className="mb-4" style={{ color: "#eee", fontWeight: '700', lineHeight: '2.65rem', letterSpacing: '2px' }}>Signup now</h3> */}
                                            <h4 style={{ color: "#eee", fontWeight: '500', lineHeight: '2.65rem', letterSpacing: '2px' }}>
                                                Genuinely Connecting Consumers to Brands.
                                                Influence change in the world with your Voice!
                                            </h4>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div >

                    </div >

                </LoadingOverlay>



            )
            }
        />

    )

}

export default ThanksYouMsg;

